// Servereinstellungen → „Webhooks" mit Tabs „Eingehend"/„Ausgehend" (Vertrag 3.13).
import type { ExtraContext } from '../index';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { lookupApi } from '../api';
import { Empty, Tabs } from '../ui';
import { IncomingWebhooks } from './IncomingWebhooks';
import { OutgoingWebhooks } from './OutgoingWebhooks';
import { channelsKey, webhookTargetChannels } from './webhooks-utils';
import './webhooks.css';

type Tab = 'incoming' | 'outgoing';

function WebhooksForServer(props: { serverId: string }) {
  const [tab, setTab] = useState<Tab>('incoming');
  const channels = useQuery({ queryKey: channelsKey(props.serverId), queryFn: () => lookupApi.channels(props.serverId) });
  const targets = webhookTargetChannels(channels.data);
  return (
    <div className="lfx-stack lfx-wh" data-testid="webhooks-settings">
      <Tabs<Tab>
        testId="webhooks-tabs"
        value={tab}
        onChange={setTab}
        items={[
          { value: 'incoming', label: 'Eingehend' },
          { value: 'outgoing', label: 'Ausgehend' },
        ]}
      />
      <div role="tabpanel">
        {tab === 'incoming' ? <IncomingWebhooks serverId={props.serverId} channels={channels.data} /> : <OutgoingWebhooks serverId={props.serverId} channels={targets} />}
      </div>
    </div>
  );
}

export function ServerWebhooksSettings(props: ExtraContext) {
  if (!props.serverId) return <Empty testId="webhooks-no-server">Kein Server ausgewählt.</Empty>;
  // key: Zustand (Tab, Dialoge) beim Serverwechsel zurücksetzen.
  return <WebhooksForServer key={props.serverId} serverId={props.serverId} />;
}
